var map = {
	"./childrensDay-land-page.png": 761,
	"./likes-img.png": 759,
	"./likes-imgx.png": 2444,
	"./mask-close.png": 649,
	"./mask-close1.png": 2445,
	"./share-get-zan.png": 655,
	"./share-invite.png": 654,
	"./shop1.png": 762,
	"./shop2.png": 763,
	"./tab0.png": 2446,
	"./tab1.png": 2447,
	"./tab2.png": 2448,
	"./zan-now.png": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2443;